import React from 'react';

import { createClassName } from 'utils/createClassName';

import './homeContentLayoutStyles.scss';

type Props = {
  theme: 'dark' | 'light';
  size: 'mini' | 'auto';
};

export const HomeContentLayoutComponent: React.FC<Props> = (props) => {
  const { children, theme, size } = props;

  const createHomePageLayoutClassName = createClassName('homeContentLayout');

  const wrapperClassName = createHomePageLayoutClassName('wrapper', {
    theme,
    size,
  });

  return <div className={wrapperClassName}>{children}</div>;
};
